import { db, storage } from '../../../firebase'

const actions = {
    // UPLOAD FILE
    async uploadFileToStore({ commit }, { path, file }) {
        try {
            let filePath   = path + '.jpeg'
            var storageRef = storage.ref(filePath)

            let resizedFilePath    = path + '_1920x1600.jpeg'
            let resizedStoragePath = storage.ref(resizedFilePath)

            await storageRef.put(file)
            console.log('Uploaded ' + file.name)

            function delay(t, v) {
                return new Promise(function(resolve) {
                    setTimeout(resolve.bind(null, v), t)
                })
            }
                
            function getURL(triesRemaining, storageRef) {
                if (triesRemaining < 0) {
                    return Promise.reject('out of tries')
                }
                
                return storageRef.getDownloadURL().then((url) => {
                    return url
                }).catch((error) => {
                    switch (error.code) {
                        case 'storage/object-not-found':
                            return delay(200).then(() => {
                            return getURL(triesRemaining - 1, storageRef)
                            })
                        default:
                            return Promise.reject(error)
                    }
                })
            }

            var url = await getURL(30, resizedStoragePath)
            console.log('url of file: ' + url)
            
            return url
        } catch(err) {
            console.log(err)
            return false
        }
    },

    // UPDATE DRAFT ENTRY
    updateDraftEntry({ commit }, draft) {
        commit('updateDraft', draft)
    },

    // CREATE ENTRY
    async createJournalEntry({ commit }, entry) {
        try {
            var entryRef = db
                .collection('entries')
                .doc()

            await entryRef.set(entry)

            let empty = {
                users: []
            }
            await db
                .collection('entries')
                .doc(entryRef.id)
                .collection('social')
                .doc('likedBy')
                .set(empty)

            return entryRef.id
        } catch(err) {
            console.log(err)
            return false
        }
    },

    // UPDATE ENTRY
    async updateJournalEntry({ commit }, entry) {
        try {
            await db
                .collection('entries')
                .doc(entry.id)
                .update(entry.data)
            return entry.id
        } catch(err) {
            console.log(err)
            return false
        }
    },

    // DELETE ENTRY
    async deleteJournalEntry({ commit }, { id, images }) {
        try {
            await db
                .collection('entries')
                .doc(id)
                .delete()
        
            for(let i = 0; i < images.length; i++) {
                let storageRef = storage.refFromURL(images[i])

                await storageRef.delete()
                console.log(storageRef + ' succesfully deleted')
            }
            return true
        } catch(err) {
            console.log(err)
            return false
        }
    },
    




    // FETCH ENTRIES
    async fetchEntries({ commit }, { visibility, commitName, timelinePreference, orderPreference, limit, artistID, feedType }) {
        if(timelinePreference === 'uploadTime') {
            var timeline = 'activity.uploadTime'
        } else if(timelinePreference === 'historicalTime') {
            var timeline = 'activity.historicalTime'
        }

        if(orderPreference === 'desc') {
            var order = 'desc'
        } else if(timelinePreference === 'asc') {
            var order = 'asc'
        }
        
        switch(feedType) {
            case 'followingEntries':
                commit('followingEntriesReachedBottom', false)
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .where('recipients', 'array-contains', artistID)
                    .orderBy('activity.uploadTime', 'desc')
                    .limit(limit)
                    .get()
                break
            case 'allEntries':
                commit('allEntriesReachedBottom', false)
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .orderBy('activity.uploadTime', 'desc')
                    .limit(limit)
                    .get()
                break
            case 'featuredEntries':
                commit('featuredEntriesReachedBottom', false)
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .where('flag.featured', '==', true)
                    .orderBy('activity.uploadTime', 'desc')
                    .limit(limit)
                    .get()
                break
            case 'userEntries':
                commit('userEntriesReachedBottom', false)
                var entriesRef = await db
                    .collection('entries')
                    .where('creator.artist', '==', artistID)
                    .where('flag.visibility', '==', visibility)
                    .orderBy(timeline, order)
                    .limit(limit)
                    .get()
                break
            case 'userDrafts':
                commit('userDraftsReachedBottom', false)
                var entriesRef = await db
                    .collection('entries')
                    .where('creator.artist', '==', artistID)
                    .where('flag.visibility', '==', visibility)
                    .orderBy(timeline, order)
                    .limit(limit)
                    .get()
        }

        const entries = entriesRef.docs.map(entry => ({
            id: entry.id,
            ...entry.data()
        }))

        for(var entry of entries) {
            var userRef = await db
                .collection('users')
                .doc(entry.creator.artist)
                .get()

            entry.creator.artist = {
                id: userRef.id,
                ...userRef.data()
            }
        }
        
        commit(commitName, entries)
    },

    async fetchEntriesAfter({ commit }, { visibility, commitName, timelinePreference, orderPreference, lastVisible, limit, artistID, feedType }) {
        var lastVisibleDoc = await db
            .doc('entries/' + lastVisible.id)
            .get()

        if(timelinePreference === 'uploadTime') {
            var timeline = 'activity.uploadTime'
        } else if(timelinePreference === 'historicalTime') {
            var timeline = 'activity.historicalTime'
        }

        if(orderPreference === 'desc') {
            var order = 'desc'
        } else if(timelinePreference === 'asc') {
            var order = 'asc'
        }
        

        switch(feedType) {
            case 'followingEntries':
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .where('recipients', 'array-contains', artistID)
                    .orderBy('activity.uploadTime', 'desc')
                    .startAfter(lastVisibleDoc)
                    .limit(limit)
                    .get()
                break
            case 'allEntries':
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .orderBy('activity.uploadTime', 'desc')
                    .startAfter(lastVisibleDoc)
                    .limit(limit)
                    .get()
                break
            case 'featuredEntries':
                var entriesRef = await db
                    .collection('entries')
                    .where('flag.visibility', '==', true)
                    .where('flag.featured', '==', true)
                    .orderBy('activity.uploadTime', 'desc')
                    .startAfter(lastVisibleDoc)
                    .limit(limit)
                    .get()
                break
            case 'userEntries':
                var entriesRef = await db
                    .collection('entries')
                    .where('creator.artist', '==', artistID)
                    .where('flag.visibility', '==', visibility)
                    .orderBy(timeline, order)
                    .startAfter(lastVisibleDoc)
                    .limit(limit)
                    .get()
                break
            case 'userDrafts':
                var entriesRef = await db
                    .collection('entries')
                    .where('creator.artist', '==', artistID)
                    .where('flag.visibility', '==', visibility)
                    .orderBy(timeline, order)
                    .startAfter(lastVisibleDoc)
                    .limit(limit)
                    .get()
        }

        const entries = entriesRef.docs.map(entry => ({
            id: entry.id,
            ...entry.data()
        }))

        for (var entry of entries) {
            var userRef = await db
                .collection('users')
                .doc(entry.creator.artist)
                .get()
                            
            entry.creator.artist = {
                id: userRef.id,
                ...userRef.data()
            }
        }

        if(entries.length < limit) {
            switch(feedType) {
                case 'followingEntries':
                    commit('followingEntriesReachedBottom', true)
                    break
                case 'allEntries':
                    commit('allEntriesReachedBottom', true)
                    break
                case 'featuredEntries':
                    commit('featuredEntriesReachedBottom', true)
                    break
                case 'userEntries':
                    commit('userEntriesReachedBottom', true)
                    break
                case 'userDrafts':
                    commit('userDraftsReachedBottom', true)
            }
        }

        commit(commitName, entries)
    },

    async fetchEntryByID({commit}, id) {
        try {
            const artworkRef = await db
                .collection('entries')
                .doc(id)
                .get()

            const artwork = {
                id: artworkRef.id,
                ...artworkRef.data()
            }

            const artistRef = await db
                .collection('users')
                .doc(artwork.creator.artist)
                .get()
            
            const storywriterRef = await db
                .collection('users')
                .doc(artwork.creator.storywriter)
                .get()

            artwork.creator.artist = {
                id: artistRef.id,
                ...artistRef.data()
            }

            artwork.creator.storywriter = {
                id: storywriterRef.id,
                ...storywriterRef.data()
            }

            commit('setCurrentArtwork', artwork)

            return true
        } catch(error) {
            return false
        }
    },

    async purgeUserEntries({ commit }) {
        var empty = []

        commit('setUserArtworks', empty)
        commit('setUserDrafts',   empty)

        commit('userEntriesReachedBottom', false)
        commit('userDraftsReachedBottom',  false)
    },



    // FETCH SINGLE ENTRY
    async getArtworkDataById({ commit }, id) {
        try {
            var artworkRef = await db
                .collection('entries')
                .doc(id)
                .get()
            
            const entry = artworkRef.data()
        
            return entry
        }
        catch (err) {
            console.log(err)
            return null
        }
    }
}

export default actions